import { Radio } from '@acin/ui-core';
import React from 'react';
import {
  IInternalRegulationDocumentInstance,
  IInternalRegulationDocumentReviewStatus,
} from '../../../graphql/generated';
import { StatusBadge } from '../../StatusBadge';
import * as SC from './Documents.styled';

interface DocumentItemProps {
  activeId?: string;
  name: string;
  id?: string;
  citation?: string;
  status?: IInternalRegulationDocumentReviewStatus;
  document?: IInternalRegulationDocumentInstance;
  onSelect: (document?: IInternalRegulationDocumentInstance) => void;
}

export const DocumentListItem: React.FC<DocumentItemProps> = (props) => {
  const { document, onSelect, activeId, id, name, status, citation } = props;

  return (
    <SC.Document key={id}>
      <SC.Title>
        <Radio
          ellipsis
          label={() => (
            <SC.Title>
              {citation && <SC.Id>{citation}</SC.Id>}
              <SC.Name ellipsis>{name}</SC.Name>
            </SC.Title>
          )}
          onChange={() => onSelect(document)}
          isChecked={activeId === id}
        />
      </SC.Title>
      {document?.createdTimestamp && (
        <SC.Date>
          {new Date(Number(document.createdTimestamp)).toLocaleDateString('en-GB', {
            day: 'numeric',
            month: 'long',
            year: 'numeric',
          })}
        </SC.Date>
      )}
      {status && (
        <SC.Status>
          <StatusBadge status={status} />
        </SC.Status>
      )}
    </SC.Document>
  );
};
